module.exports = __webpack_public_path__ + "img/produkt-na-gril.d160446b.jpg";